import React from 'react';

const NotReady = (props: any) => {
  return (
    <svg {...props} width="80" height="48" viewBox="0 0 80 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="80" height="48" rx="6" />
      <rect width="80" height="48" rx="6" fill="url(#paint0_linear_36048_29345)" />
      <path
        d="M36.7115 22.8871L36.7116 9.42307M43.2885 22.8871L43.2885 9.42307M36.7115 18.7404H32.875M36.7115 13.2596H32.875M46.5769 18.7404H43.2885M46.5769 13.2596H43.2885M32.875 11.875L32.875 20.125C32.875 21.7818 34.2181 23.125 35.875 23.125L44.125 23.125C45.7819 23.125 47.125 21.7818 47.125 20.125V11.875C47.125 10.2182 45.7819 8.87502 44.125 8.87502L35.875 8.875C34.2182 8.875 32.875 10.2181 32.875 11.875Z"
        stroke="white"
        stroke-linecap="round"
      />
      <defs>
        <linearGradient id="paint0_linear_36048_29345" x1="40" y1="0" x2="40" y2="48" gradientUnits="userSpaceOnUse">
          <stop stop-color="#4E46B4" />
          <stop offset="1" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NotReady;
